import gql from 'graphql-tag';

export const deleteNoteType = gql`
  mutation deleteNoteType($id: String) {
    deleteNoteType(id: $id)
  }
`;
